import { Alert, Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUserTag } from "@fortawesome/free-solid-svg-icons";
import { Fragment, useEffect, useState } from "react";
import { addOrUpdateSaleCompetitor, deleteSaleCompetitor, getSaleCompetitorList } from "../store/api/CustomerApi";
import { setDialog, translateError } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { CheckLg, DashCircle, PencilFill, PlusSquare, Tiktok } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
export default function ModalSaleCompatitors(props) {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { show } = popData;
    const [isPending, setPending] = useState(false);
    const [dataList, setDataList] = useState();
    const [currentComp, setCurrentComp] = useState();
    const [ submitError, setSubmitError ] = useState();
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "نام", colName: "Name", showInMobile: true },
        { colTitle: "شرح", colName: "Description", showInMobile: true },
        { colTitle: "فعال", colName: "IsActive", colType: "boolean" }
    ]
    const rowButtons = [
        { title: "ویرایش", type: "common", icon: <PencilFill color="orange" size="18" />, className: "group-Btn-smalll", onclick: prepareForEdit },
        {
            title: "حذف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: deleteComp
        }
    ]
    function close() {
        setPopData({ show: false });
        setCurrentComp(null);
        setSubmitError(null);
    }
    function prepareForAdd() {
        setCurrentComp({ ID: 0 });
    }
    function prepareForEdit(row) {
        delete row.e;
        setCurrentComp({ ...row });
    }
    function submitCurrentComp() {
        if (!currentComp) {
            setSubmitError("ردیفی انتخاب نشده است");
        }
        setPending(true);
        const onAddEdit = (res) => {
            setPending(false);
            if (res.Data) {
                if(!currentComp.ID)
                {
                currentComp.ID = Number(res.Data);
                dataList.Data.push({ ...currentComp });
                }
                else{
                    const found = dataList.Data.find(d=>Number(d.ID) === Number(currentComp.ID));
                    Object.assign(found, currentComp);
                }
                //setDataList({ ...dataList });
                setCurrentComp(null);
            }
            else if (res.Error) {
                setSubmitError(translateError(res.Error));
            }

        }
        addOrUpdateSaleCompetitor(currentComp, onAddEdit);
    }
    function deleteComp(item) {
        const onDelete = (res) => {
            if (res.Data) {
                dataList.Data = dataList.Data.filter(d => Number(d.ID) !== Number(res.Data));
                setDataList({ ...dataList });
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => { deleteSaleCompetitor(item.ID, onDelete) }
        }));
    }
    function cancel()
    {
        setCurrentComp(null);
        setSubmitError(null);
    }
    useEffect(() => {
        if (show) {
            getSaleCompetitorList(setDataList);
        }
    }, [show]);
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faUserTag} size="lg" />&nbsp;
                    مدیریت رقبای فروش
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body>
                {submitError &&
                    <Alert variant="danger">
                        {submitError}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>
                }
                <Button className="group-Btn-smalll" onClick={prepareForAdd} ><PlusSquare size={18} /></Button>

                {currentComp &&
                    <Row className="rowBorder mt-1">
                        <FormGroup className="col-md-5">
                            <Form.Control placeholder="نام" defaultValue={currentComp.Name ?? ""} onChange={e => currentComp.Name = e.target.value} />
                        </FormGroup>
                        <FormGroup className="col-md-7">
                            <Form.Control placeholder="توضیحات" defaultValue={currentComp.Description ?? ""} onChange={e => currentComp.Description = e.target.value} />
                        </FormGroup>
                        <FormGroup className="col-md-5">
                            <input type="checkbox" id="chkActiveSaleComp" className="form-check-input" 
                            defaultChecked={currentComp.IsActive?.toString() ==="true" }  
                            onChange={e => currentComp.IsActive = e.target.checked}/>&nbsp;
                            <label htmlFor="chkActiveSaleComp" style={{color:"blue", marginTop:"2px"}}>فعال است</label>
                        </FormGroup>
                        <div className="mt-1">
                            <Button className="group-Btn" variant="success" onClick={submitCurrentComp}>
                                {currentComp.ID ?
                                    <Fragment>
                                        <PencilFill size={18} />&nbsp;ویرایش
                                    </Fragment> :
                                    <Fragment>
                                        <CheckLg size={17} />&nbsp; ثبت اطلاعات
                                    </Fragment>
                                }
                            </Button>
                            <Button className="group-Btn" variant="danger" onClick={cancel}><DashCircle size={18}/>&nbsp;انصراف</Button>
                        </div>
                    </Row>
                }
                <BihamtaTable columns={tableCols} rowButtons={rowButtons} dataList={dataList} maxHeight={500} />
            </Modal.Body>
        </Modal>
    )
}